module.exports = __webpack_public_path__ + "img/10002.ea6990dd.jpg";